<section id="check-by-email-section" class="section-card-content" data-cy="withdraw-check-screen">
  <form [formGroup]="checkByEmailForm">
    <p class="details tw-font-bold tw-text-[15px] tw-text-[#0F2950]" data-cy="withdraw-check-details">
      {{ 'account.funding.withdraw.check.pleaseconfirm' | translate: 'Please confirm your information and address below:' }}
    </p>

    <div class="deposit-details tw-mb-[15px]">

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]" data-cy="withdraw-check-name">{{ 'generic.name' | translate: 'Name' }}</span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]" data-cy="withdraw-check-full-name">{{ fullName }}</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]" data-cy="withdraw-check-address">{{ 'generic.address' | translate: 'Address' }}</span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]" data-cy="withdraw-check-user-address">{{ address }}</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]" data-cy="withdraw-check-location">{{ 'generic.location' | translate: 'Location' }}</span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]" data-cy="withdraw-check-user-location">{{ location }}</span>
        </div>
      </div>

    </div>

    <p class="notice1 tw-text-[14px] tw-text-[#0F2950] tw-mb-[12px]" data-cy="withdraw-check-notice1">
      {{ 'account.funding.withdraw.check.inform' | translate }}
    </p>

    <p class="notice2 tw-text-[14px] tw-text-[#0F2950] tw-mb-[30px]" data-cy="withdraw-check-notice2">
      <span class="note tw-font-bold">{{ 'generic.note' | translate: 'Note:' }}</span> {{ 'ui.funding.amwest.entertainment.will.process.your.check' | translate: 'AmWest Entertainment will process your check request within 5 business days. Should you wish to use expedited shipping please contact our support team.' }}
    </p>

    <div class="amount-row tw-relative">
      <!-- Message section -->
      <!-- tw-top-[-18px] -->
      <span class="tw-absolute tw-bottom-[-19px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['amount'] && formVal['amount']?.errors
            && (formVal['amount'].touched || formVal['amount'].dirty)"
          data-cy="withdraw-check-error">
          {{
            'ui.funding.enter.valid.amount' | translate: 'Please enter valid amount.'
          }}
        </span>
      </span>

      <span class="amount-deposit-usd tw-block tw-text-[16px] tw-text-[#5D5D5D]" data-cy="withdraw-check-amount-label">
        {{ 'account.funding.withdraw.amountto' | translate: 'Amount to be Withdrawn' }}
      </span>
      <input
        formControlName="amount"
        id="depositAmount"
        (keyup)="withdrawAmount()"
        type="number"
        class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
        placeholder=""
        pattern="^\d+(\.\d{1,2})?$"
        amwager3DecimalInput
        data-cy="withdraw-check-amount-input"
      />
    </div>

    <div class="tw-flex tw-mt-[15px]">
      <mat-checkbox
        [checked]="isAgree"
        (change)="toggleCheckbox()"
        id="isAgree"
        class="tw-top-1 tw-mr-2 tw-mt-0 tw-mb-0"
        data-cy="withdraw-check-checkbox">
      </mat-checkbox>
      <p (click)="toggleCheckbox()" class="isAgree tw-font-bold tw-text-[15px] tw-text-[#0F2950]" data-cy="withdraw-check-checkbox-text">
        {{ 'account.funding.withdraw.check.agree' | translate: 'I Agree to the Above Terms and Confirm the shown information is correct.' }}
      </p>
    </div>

    <button
      (click)="withdraw()"
      [ngClass]="{'active': (isAgree && amount && !isProcessing && formVal['amount'].valid)}"
      [disabled]="!isAgree || !amount || isProcessing || formVal['amount'].invalid"
      class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[30px] tw-mb-[10px]"
      data-cy="withdraw-check-button"
    >
      {{ 'account.funding.withdraw.credit.btn.withdraw' | translate: 'Withdraw Now' }}
    </button>

    <p class="notice tw-text-center tw-text-[14px] tw-text-[#3080EC]" data-cy="withdraw-check-notice">
      {{ 'account.funding.iprecorded' | translate: 'Your IP Address and location will be recorded for fraud prevention purposes.' }}
    </p>
  </form>
</section>
